import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  IManualShipmentPayload,
  IShipment,
  IShipmentFormData,
  TShipmentFormDataSource,
} from '../../interfaces/order-shipment.interface';
import { EnvironmentUtilService } from '../util';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class ShipstationShipmentApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getShipmentById(
    id :number,
    params :{ [param :string] :string },
  ) :Observable<IShipment> {
    return this.apiService.get(
      `${this.environment.urlV2}/inventory/ship-station-shipments/${id}`,
      {
        params,
      },
    );
  }

  getShipmentDataFromSource(params :{
    source :TShipmentFormDataSource;
    sourceId :number;
  }) :Observable<IShipmentFormData> {
    return this.apiService.get(
      `${this.environment.urlV2}/inventory/shipments/data`,
      {
        params,
      },
    );
  }

  createManualShipment(payload :IManualShipmentPayload) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/inventory/ship-station-shipments/manual`,
      body: { ...payload },
    });
  }

  updateManualShipment(
    id :number,
    payload :IManualShipmentPayload,
  ) :Observable<any> {
    return this.apiService.put(
      `${this.environment.urlV2}/inventory/ship-station-shipments/manual/${id}`,
      payload,
    );
  }

  deleteShipment(id :number) :Observable<any> {
    return this.apiService.delete(
      `${this.environment.urlV2}/inventory/ship-station-shipments/${id}`,
    );
  }
}
